import ReactDOM from 'react-dom';
/***
 * popupの背景
 */
export const BackgroundLayer = ({ modalRoot, children }) => {
  const _modalRoot = document.getElementById(modalRoot);
  return ReactDOM.createPortal(children, _modalRoot);
};



// WEBPACK FOOTER //
// ./src/components/modals/BackgroundLayer.jsx